import React, { useEffect } from 'react'
import { Input, Button, Modal, Form } from 'antd'
import PropTypes from 'prop-types'
import { Select } from 'antd'
import { useQuery } from '@tanstack/react-query'

import { profileOptions } from 'utils/constants'
import { errorMessage } from 'services/messager'
import { getCompanyTeams } from 'services/demands/teamsServices'

const UserEditModal = ({
	handleUpdate,
	handleCancel,
	handleEditUser,
	editUser,
	showModal,
	groups,
}) => {
	const { data: teams, isLoading: isLoadingTeams } = useQuery({
		queryKey: ['team-options'],
		queryFn: fetchTeams,
		staleTime: 1000 * 30,
		refetchOnWindowFocus: false,
		retry: false,
	})

	const [form] = Form.useForm()

	useEffect(() => {
		if (showModal && editUser) {
			form.setFieldsValue({
				name: editUser.name,
				email: editUser.email,
				groups: editUser.groups,
				perfil: editUser?.perfil,
				teams: editUser?.teams?.map((team) => (team?.id ? team.id : team)),
			})
		}
	}, [showModal, editUser.id])

	async function fetchTeams() {
		try {
			const { list: teams } = await getCompanyTeams(1, 100)

			return teams
		} catch (error) {
			console.log(error)
			errorMessage({
				content: 'Erro ao carregar times',
			})
		}
	}

	const getSelectOptions = (options) => {
		if (!options?.length) return null

		return (
			<>
				{options.map((option) => (
					<Select.Option
						key={`editusermodal-${option.id}-${option.name}`}
						value={option.id}>
						{option.name}
					</Select.Option>
				))}
			</>
		)
	}

	return (
		<Modal
			forceRender
			open={showModal}
			onCancel={handleCancel}
			footer={[
				<Button key="cancelar" onClick={handleCancel}>
					Cancelar
				</Button>,
				<Button key="atualizar" onClick={handleUpdate} form="editUserForm">
					Salvar
				</Button>,
			]}>
			<Form form={form} id="editUserForm" onChange={() => handleEditUser(form)}>
				<Form.Item label="Editar usuário"></Form.Item>
				<Form.Item label="Nome" name="name">
					<Input disabled={true} />
				</Form.Item>
				<Form.Item label="Email" name="email">
					<Input disabled={true} />
				</Form.Item>
				<Form.Item label="Grupos" name="groups">
					<Select
						mode="multiple"
						allowClear
						style={{ width: '100%' }}
						placeholder="Selecione o grupo"
						onChange={() => handleEditUser(form)}>
						{getSelectOptions(groups)}
					</Select>
				</Form.Item>
				<Form.Item label="Perfil" name="perfil">
					<Select
						style={{ width: '100%' }}
						placeholder="Selecione o perfil"
						onChange={() => {
							handleEditUser(form)
						}}>
						{getSelectOptions(profileOptions)}
					</Select>
				</Form.Item>
				<Form.Item label="Times" name="teams">
					<Select
						mode="multiple"
						allowClear
						style={{ width: '100%' }}
						placeholder="Selecione os times"
						onChange={() => {
							handleEditUser(form)
						}}
						loading={isLoadingTeams}>
						{!isLoadingTeams && getSelectOptions(teams)}
					</Select>
				</Form.Item>
			</Form>
		</Modal>
	)
}

UserEditModal.propTypes = {
	handleUpdate: PropTypes.func,
	handleCancel: PropTypes.func,
	handleEditUser: PropTypes.func,
	editUser: PropTypes.object,
	showModal: PropTypes.bool,
	groups: PropTypes.array,
}

UserEditModal.defaultProps = {
	groups: [],
}

export default UserEditModal
